export default __webpack_public_path__ + "static/media/S3BannerGetDigitalExpertise.59cd0bb3.png";